import type { Fest } from "../types";

export const FESTS: Fest[] = [
  {
    id: "mothman-festival",
    name: "Mothman Festival",
    shortName: "Mothman Festival",
    kinds: ["cryptid"],
    region: "Northeast",
    country: "US",
    state: "WV",
    city: "Point Pleasant",
    venue: "Downtown Point Pleasant / Mothman Museum",
    latitude: 38.844,
    longitude: -82.137,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival", "museum"],
    whyGo:
      "The country’s biggest cryptid street weekend, in the town that named it. Museum year-round; the festival is the pilgrimage.",
    campingNotes:
      "Downtown is day-use. Chief Cornstalk and Beech Fork wildlife areas, plus Ohio-side parks across the river. Hotels book out a year ahead for festival weekend.",
    tripNotes:
      "September 19–20, 2026. Free admission. Confirm speakers and map on the festival’s Facebook / mothmanmuseum.com. US-35 to the Ohio River.",
    etiquette:
      "The TNT area and wildlife refuge have real access rules. Don’t trespass for a night-vision clip. Support the museum; it is why the town still has this.",
    typical: {
      startMonth: 9,
      startDay: 19,
      endMonth: 9,
      endDay: 20,
      cadence: "single",
      notes: "Third weekend of September, typical.",
    },
    seasons: [
      { start: "2026-09-19", end: "2026-09-20", cadence: "single" },
    ],
    officialUrl: "https://www.mothmanmuseum.com/",
  },
  {
    id: "texas-bigfoot-conference",
    name: "Texas Bigfoot Conference",
    shortName: "Texas Bigfoot",
    kinds: ["cryptid"],
    region: "South",
    country: "US",
    state: "TX",
    city: "Jefferson",
    venue: "Jefferson Tourism & Visitor Center",
    latitude: 32.757,
    longitude: -94.345,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival"],
    whyGo:
      "East Texas piney-woods Bigfoot research, in a river town that already does haunted hotels. One trip covers cryptids and ghosts.",
    campingNotes:
      "Caddo Lake State Park, Black Cypress, and Jefferson RV parks. Historic B&Bs if you want the haunt layer. The conference itself is not a campground.",
    tripNotes:
      "October 16–18, 2026. Confirm on texasbigfoot.org. I-20 to Marshall, then north. Pair with Caddo Lake at night.",
    etiquette:
      "This crowd takes field reports seriously. Don’t fake prints on public land. Jefferson after dark is a neighborhood.",
    typical: {
      startMonth: 10,
      startDay: 16,
      endMonth: 10,
      endDay: 18,
      cadence: "single",
      notes: "Mid-October weekend.",
    },
    seasons: [
      { start: "2026-10-16", end: "2026-10-18", cadence: "single" },
    ],
    officialUrl: "https://www.texasbigfoot.org/",
  },
  {
    id: "ohio-bigfoot-conference",
    name: "Ohio Bigfoot Conference",
    shortName: "Ohio Bigfoot",
    kinds: ["cryptid"],
    region: "Midwest",
    country: "US",
    state: "OH",
    city: "Cambridge",
    venue: "Pritchard Laughlin Civic Center",
    latitude: 40.031,
    longitude: -81.588,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival"],
    whyGo:
      "One of the longest-running Sasquatch conferences in the country. Salt Fork woods are next door if you want a night in the trees after the talks.",
    campingNotes:
      "Salt Fork State Park is the camping move. Cambridge hotels for the conference crowd. Not an on-site lot.",
    tripNotes:
      "May 2, 2026 (38th conference). Confirm on the organizer’s page. I-70 to Cambridge.",
    etiquette:
      "Indoor conference. Salt Fork after hours is still a state park — quiet hours and no off-trail tracking fantasies.",
    typical: {
      startMonth: 5,
      startDay: 2,
      endMonth: 5,
      endDay: 2,
      cadence: "single",
      notes: "Early May.",
    },
    seasons: [
      { start: "2026-05-02", end: "2026-05-02", cadence: "single" },
    ],
    officialUrl: "https://ohiobigfootconference.com/",
  },
  {
    id: "honobia-bigfoot",
    name: "Honobia Bigfoot Festival",
    shortName: "Honobia",
    kinds: ["cryptid"],
    region: "South",
    country: "US",
    state: "OK",
    city: "Honobia",
    venue: "Kiamichi Mountains / Honobia community grounds",
    latitude: 34.539,
    longitude: -94.726,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival", "night-watch"],
    whyGo:
      "A mountain Bigfoot weekend on the Oklahoma–Arkansas line. Closer to a woods trip than a convention-center conference.",
    campingNotes:
      "Ouachita / Kiamichi camping and primitive pads. Honobia is tiny. Bring everything. This is a van-in-the-trees trip with a festival attached.",
    tripNotes:
      "Typically early October. Confirm locally before you commit the dirt roads. US-259 / OK-144 country.",
    etiquette:
      "Working timber and community land. Closed gates stay closed. Night hikes only where posted.",
    typical: {
      startMonth: 10,
      startDay: 3,
      endMonth: 10,
      endDay: 5,
      cadence: "single",
      notes: "Early October; confirm annually.",
    },
    seasons: [
      { start: "2026-10-03", end: "2026-10-05", cadence: "single" },
    ],
    officialUrl: "https://www.honobiabigfoot.com/",
  },
  {
    id: "ouachita-bigfoot-festival",
    name: "Ouachita Bigfoot Festival & Conference",
    shortName: "Ouachita Bigfoot",
    kinds: ["cryptid"],
    region: "South",
    country: "US",
    state: "AR",
    city: "Mena",
    venue: "The Blue; Zip Line & Farm, 142 Polk Road 185",
    latitude: 34.615,
    longitude: -94.132,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "festival", "night-watch"],
    whyGo:
      "A small Ouachita-mountain Bigfoot weekend on a zipline farm: free admission, roundtable, night expeditions, campfire stories. Pronounced Washitah. The Arkansas-side pin across the ridge from Honobia.",
    campingNotes:
      "On-site dry camping — tents and self-contained RVs. No water/electric/sewer on the pad; shower house on the farm. Parking $5; camping is a separate farm fee (call to reserve). Check-in 9am–3pm Fri/Sat.",
    tripNotes:
      "October 9–10, 2026. Hwy 88 East, about five miles out of Mena; follow signs. Free pedal-boat rides, vendors, Jason Farthing’s flying keyboard. Confirm on blueziplinefarm.com. Benefits the Ouachita Land Conservation Fund.",
    etiquette:
      "Private farm, not National Forest. Expeditions are hosted — don’t freelance into a neighbor’s timber at midnight. Pack out. Leashed dogs only.",
    typical: {
      startMonth: 10,
      startDay: 9,
      endMonth: 10,
      endDay: 10,
      cadence: "single",
      notes: "October weekend; moved off September heat.",
    },
    seasons: [
      { start: "2026-10-09", end: "2026-10-10", cadence: "single" },
    ],
    officialUrl: "https://blueziplinefarm.com/ouachita-bigfoot-festival-conference",
  },
  {
    id: "fouke-monster-festival",
    name: "Fouke Monster Festival",
    shortName: "Fouke Monster",
    kinds: ["cryptid"],
    region: "South",
    country: "US",
    state: "AR",
    city: "Fouke",
    venue: "Downtown Fouke",
    latitude: 33.261,
    longitude: -93.885,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "festival"],
    whyGo:
      "Boggy Creek country. The Southern Sasquatch that got a drive-in movie, still celebrated in a town you can actually camp near.",
    campingNotes:
      "Sulphur River / Atlanta State Park (TX) and local RV pads. Fouke itself is a wide spot. Texarkana is supplies.",
    tripNotes:
      "Typically spring or early summer. Confirm the current year before you roll. US-71 south of Texarkana.",
    etiquette:
      "Private timber and creek bottoms are not a film set. Stay on public roads at night.",
    typical: {
      startMonth: 4,
      startDay: 25,
      endMonth: 4,
      endDay: 26,
      cadence: "single",
      notes: "Spring weekend; confirm annually.",
    },
    seasons: [
      { start: "2026-04-25", end: "2026-04-26", cadence: "single" },
    ],
    officialUrl: "https://www.foukemonster.net/",
  },
  {
    id: "metaline-falls-bigfoot",
    name: "Metaline Falls Bigfoot Festival",
    shortName: "Metaline Falls",
    kinds: ["cryptid"],
    region: "West",
    country: "US",
    state: "WA",
    city: "Metaline Falls",
    venue: "Busta Park / downtown Metaline Falls",
    latitude: 48.863,
    longitude: -117.373,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival"],
    whyGo:
      "A small-town Selkirk Mountains Bigfoot weekend. The camping is the forest; the festival is Father’s Day in town.",
    campingNotes:
      "Colville National Forest and Pend Oreille camps. The town lots are day parking. This is a van-in-the-woods trip.",
    tripNotes:
      "June 20–21, 2026. WA-31. Confirm locally. Pair with a night up the Pend Oreille.",
    etiquette:
      "Tiny downtown. Don’t block the three restaurants. Forest Service rules after dark.",
    typical: {
      startMonth: 6,
      startDay: 20,
      endMonth: 6,
      endDay: 21,
      cadence: "single",
      notes: "Father’s Day weekend.",
    },
    seasons: [
      { start: "2026-06-20", end: "2026-06-21", cadence: "single" },
    ],
    officialUrl: "https://www.pendoreillerivervalley.com/",
  },
  {
    id: "central-pa-bigfoot",
    name: "Central PA Bigfoot & Cryptid Festival",
    shortName: "Central PA Cryptids",
    kinds: ["cryptid"],
    region: "Northeast",
    country: "US",
    state: "PA",
    city: "Selinsgrove",
    venue: "Selinsgrove festival grounds",
    latitude: 40.8,
    longitude: -76.862,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "festival"],
    whyGo:
      "A large East Coast cryptid gathering in the Susquehanna valley — Bigfoot plus the rest of the menagerie.",
    campingNotes:
      "Susquehanna state and private camps. Selinsgrove / Shamokin Dam hotels. Not typically an on-site lot.",
    tripNotes:
      "August 15, 2026. Confirm the current venue. US-11/15.",
    etiquette:
      "Family festival energy. Night woods are still someone else’s land.",
    typical: {
      startMonth: 8,
      startDay: 15,
      endMonth: 8,
      endDay: 16,
      cadence: "single",
      notes: "Mid-August.",
    },
    seasons: [
      { start: "2026-08-15", end: "2026-08-16", cadence: "single" },
    ],
    officialUrl: "https://www.northwestbigfoot.com/bigfoot-events/",
  },
  {
    id: "smoky-mountain-bigfoot",
    name: "Smoky Mountain Bigfoot Conference",
    shortName: "Smoky Mountain Bigfoot",
    kinds: ["cryptid"],
    region: "Southeast",
    country: "US",
    state: "TN",
    city: "Gatlinburg",
    venue: "Gatlinburg Convention Center",
    latitude: 35.714,
    longitude: -83.51,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival"],
    whyGo:
      "Indoor talks, then the actual Smokies at night. A conference you can turn into a park camping trip.",
    campingNotes:
      "Great Smoky Mountains National Park camps (Elkmont, Smokemont) and Pigeon Forge RV parks. Gatlinburg itself is hotels.",
    tripNotes:
      "July 25, 2026. Confirm on gatherupevents.com / the conference page. I-40 to 441.",
    etiquette:
      "The park is not a night-hunt concession. Stay in legal camps. Bears are not cryptids here.",
    typical: {
      startMonth: 7,
      startDay: 25,
      endMonth: 7,
      endDay: 25,
      cadence: "single",
      notes: "Late July.",
    },
    seasons: [
      { start: "2026-07-25", end: "2026-07-25", cadence: "single" },
    ],
    officialUrl: "https://gatherupevents.com/bigfoot-conferences-and-events/",
  },
  {
    id: "florida-bigfoot-conference",
    name: "Great Florida Bigfoot Conference",
    shortName: "Florida Bigfoot",
    kinds: ["cryptid"],
    region: "Southeast",
    country: "US",
    state: "FL",
    city: "Ocala",
    venue: "World Equestrian Center",
    latitude: 29.187,
    longitude: -82.14,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival"],
    whyGo:
      "Sasquatch in horse country. Ocala National Forest is the overnight if you want actual woods after the Expo hall.",
    campingNotes:
      "Ocala NF recreation areas and WEC-area RV. Summer Florida heat is the other speaker.",
    tripNotes:
      "June 12–13, 2026. Confirm on the conference site. I-75.",
    etiquette:
      "Convention-center manners inside; forest rules outside. No spotlighting wildlife.",
    typical: {
      startMonth: 6,
      startDay: 12,
      endMonth: 6,
      endDay: 13,
      cadence: "single",
      notes: "Mid-June.",
    },
    seasons: [
      { start: "2026-06-12", end: "2026-06-13", cadence: "single" },
    ],
    officialUrl: "https://gatherupevents.com/bigfoot-conferences-and-events/",
  },
  {
    id: "roswell-ufo-festival",
    name: "Roswell UFO Festival",
    shortName: "Roswell UFO Fest",
    kinds: ["ufo"],
    region: "Southwest",
    country: "US",
    state: "NM",
    city: "Roswell",
    venue: "Downtown Roswell / Pioneer Plaza",
    latitude: 33.3943,
    longitude: -104.523,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "festival", "museum"],
    whyGo:
      "The American UFO weekend. Parade, speakers, International UFO Museum year-round. Bottomless Lakes is the dark-sky camping sequel.",
    campingNotes:
      "Bottomless Lakes State Park is the overnight that makes this a trip. In-town RV parks and hotels for the parade nights. The plaza is not a campground.",
    tripNotes:
      "July 2–4, 2026. Confirm on roswell-nm.gov / ufofestival.com. US-285 / US-70.",
    etiquette:
      "Downtown is a neighborhood. The ranch crash site is private land — pay for the tour, don’t invent a road.",
    typical: {
      startMonth: 7,
      startDay: 2,
      endMonth: 7,
      endDay: 4,
      cadence: "single",
      notes: "Independence Day weekend.",
    },
    seasons: [
      { start: "2026-07-02", end: "2026-07-04", cadence: "single" },
    ],
    officialUrl: "https://www.ufofestival.com/",
  },
  {
    id: "mcminnville-ufo",
    name: "McMinnville UFO Festival",
    shortName: "McMinnville UFO",
    kinds: ["ufo"],
    region: "West",
    country: "US",
    state: "OR",
    city: "McMinnville",
    venue: "McMenamins Hotel Oregon / downtown",
    latitude: 45.2101,
    longitude: -123.197,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "festival"],
    whyGo:
      "Second-largest UFO fest in the US, built on the 1950 Trent photos. Wine country by day, aliens by night.",
    campingNotes:
      "Willamette Valley RV parks and Champoeg. The Hotel Oregon is the haunt-adjacent stay if you want walls. Not an infield lot.",
    tripNotes:
      "May 14–17, 2026. Confirm on ufofest.com. 99W from Portland.",
    etiquette:
      "Small downtown. Costume is the sport; sidewalks still belong to locals.",
    typical: {
      startMonth: 5,
      startDay: 14,
      endMonth: 5,
      endDay: 17,
      cadence: "single",
      notes: "Mid-May.",
    },
    seasons: [
      { start: "2026-05-14", end: "2026-05-17", cadence: "single" },
    ],
    officialUrl: "https://www.ufofest.com/",
  },
  {
    id: "international-ufo-congress",
    name: "International UFO Congress",
    shortName: "UFO Congress",
    kinds: ["ufo"],
    region: "Southwest",
    country: "US",
    state: "AZ",
    city: "Scottsdale",
    venue: "We-Ko-Pa / Scottsdale conference site",
    latitude: 33.494,
    longitude: -111.926,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "festival"],
    whyGo:
      "The big UAP conference: speakers, film, the research crowd rather than a Main Street parade. Tonto National Forest is the camping out.",
    campingNotes:
      "Lost Dutchman, Usery, and Tonto camps if you want desert overnight. Scottsdale is hotels. Summer heat is not theoretical.",
    tripNotes:
      "September 17–20, 2026. Confirm on ufocongress.com.",
    etiquette:
      "Conference badges. Don’t turn the parking garage into a skywatch without asking.",
    typical: {
      startMonth: 9,
      startDay: 17,
      endMonth: 9,
      endDay: 20,
      cadence: "daily",
      notes: "September.",
    },
    seasons: [
      { start: "2026-09-17", end: "2026-09-20", cadence: "daily" },
    ],
    officialUrl: "https://ufocongress.com/",
  },
  {
    id: "salem-haunted-happenings",
    name: "Salem Haunted Happenings",
    shortName: "Salem October",
    kinds: ["haunt"],
    region: "Northeast",
    country: "US",
    state: "MA",
    city: "Salem",
    venue: "Downtown Salem",
    latitude: 42.5195,
    longitude: -70.8967,
    overnight: "nearby",
    rvFriendly: false,
    tags: ["festival", "nearby-camp"],
    whyGo:
      "The country’s largest Halloween city month. History, witchcraft tourism, and more ghosts per brick than anywhere you can walk.",
    campingNotes:
      "Salem is not an RV city in October. North Shore camps and Danvers / Peabody hotels. Book months ahead. Long rigs should not try downtown.",
    tripNotes:
      "October 1–31, 2026. Grand Parade October 1. Confirm on salem.org. Commuter rail from Boston is the sane move.",
    etiquette:
      "It is a living city, not a theme park. Residences and graveyards have rules. Consent on photos of people in costume.",
    typical: {
      startMonth: 10,
      startDay: 1,
      endMonth: 10,
      endDay: 31,
      cadence: "daily",
      notes: "All of October.",
    },
    seasons: [
      { start: "2026-10-01", end: "2026-10-31", cadence: "daily" },
    ],
    officialUrl: "https://www.salem.org/haunted-happenings/",
  },
  {
    id: "stanley-hotel",
    name: "Stanley Hotel",
    shortName: "Stanley Hotel",
    kinds: ["haunt"],
    region: "West",
    country: "US",
    state: "CO",
    city: "Estes Park",
    venue: "333 Wonderview Avenue",
    latitude: 40.383,
    longitude: -105.518,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["overnight-hunt", "year-round", "nearby-camp", "rv-friendly"],
    whyGo:
      "The Overlook’s living cousin. Night tours and rooms you can actually book, with Rocky Mountain National Park as the camping alternative.",
    campingNotes:
      "Sleep in the hotel if that’s the hunt. Otherwise RMNP and Estes Park private camps. The hotel lot is not boondocking.",
    tripNotes:
      "Year-round. Ghost tours sell out in October. Confirm on stanleyhotel.com. I-25 to US-36.",
    etiquette:
      "Guests are sleeping. Night tours have routes. Don’t wander closed floors with a recorder.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Tours and rooms year-round; October is the crush.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.stanleyhotel.com/",
  },
  {
    id: "crescent-hotel",
    name: "1886 Crescent Hotel",
    shortName: "Crescent Hotel",
    kinds: ["haunt"],
    region: "South",
    country: "US",
    state: "AR",
    city: "Eureka Springs",
    venue: "75 Prospect Avenue",
    latitude: 36.402,
    longitude: -93.738,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["overnight-hunt", "year-round", "nearby-camp", "rv-friendly"],
    whyGo:
      "Ozark hilltop haunt: America’s most-marketed haunted hotel, with a town full of Victorian streets and nearby lakes for the van.",
    campingNotes:
      "Hotel if you want the overnight hunt. Lake Leatherwood and Eureka RV parks otherwise. Downtown streets are not a campground.",
    tripNotes:
      "Year-round ghost tours. Confirm on crescent-hotel.com. US-62.",
    etiquette:
      "Working hotel. Tours have a script and a path. Cemetery visits have posted hours.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Year-round.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.crescent-hotel.com/",
  },
  {
    id: "trans-allegheny-asylum",
    name: "Trans-Allegheny Lunatic Asylum",
    shortName: "Trans-Allegheny",
    kinds: ["haunt"],
    region: "Northeast",
    country: "US",
    state: "WV",
    city: "Weston",
    venue: "71 Asylum Drive",
    latitude: 39.038,
    longitude: -80.471,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["overnight-hunt", "nearby-camp", "rv-friendly", "museum"],
    whyGo:
      "A Kirkbride-plan asylum you can tour by day and book as a ghost hunt after dark. Pair with Mothman if you are already on a WV loop.",
    campingNotes:
      "Stonewall Resort State Park and local RV. The asylum does overnight investigations — those are ticketed indoor stays, not van camping on the lawn.",
    tripNotes:
      "Seasonal tours; overnight hunts on selected dates. Confirm on trans-alleghenylunaticasylum.com. I-79.",
    etiquette:
      "This was a hospital. No mockery of patients, no trespass, no unbooked night entries. Follow the investigation rules you paid for.",
    typical: {
      startMonth: 3,
      startDay: 15,
      endMonth: 11,
      endDay: 15,
      cadence: "daily",
      notes: "Tour season spring–fall; hunts on selected nights.",
    },
    seasons: [
      { start: "2026-03-15", end: "2026-11-15", cadence: "daily" },
    ],
    officialUrl: "https://trans-alleghenylunaticasylum.com/",
  },
  {
    id: "ohio-state-reformatory",
    name: "Ohio State Reformatory",
    shortName: "OSR Mansfield",
    kinds: ["haunt"],
    region: "Midwest",
    country: "US",
    state: "OH",
    city: "Mansfield",
    venue: "100 Reformatory Road",
    latitude: 40.6272,
    longitude: -82.515,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["overnight-hunt", "nearby-camp", "museum"],
    whyGo:
      "Shawshank’s prison, ghost hunts after dark, Inkcarceration on the same grounds in July. Haunt trip and metal lot can share a weekend if you plan it.",
    campingNotes:
      "Richland County Fairgrounds camping during Inkcarceration; otherwise nearby parks and hotels. The prison yard is not a campground.",
    tripNotes:
      "Tours year-round-ish; public ghost hunts on set nights. Confirm on ohiostatereformatory.org. I-71.",
    etiquette:
      "Historic prison. Stay with your group on hunts. No rubbing cell graffiti into a souvenir.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Tours most of the year; hunts seasonal.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.ohiostatereformatory.org/",
  },
  {
    id: "marfa-lights",
    name: "Marfa Lights Viewing Area",
    shortName: "Marfa Lights",
    kinds: ["ufo", "haunt"],
    region: "Southwest",
    country: "US",
    state: "TX",
    city: "Marfa",
    venue: "US-90 viewing area east of town",
    latitude: 30.273,
    longitude: -103.885,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["night-watch", "nearby-camp", "rv-friendly", "year-round"],
    whyGo:
      "A West Texas night watch you can actually do from a pullout. Lights that may be cars, may not — either way it’s a dark-sky overnight with a mystery attached.",
    campingNotes:
      "The official viewing area is not a campground. Davis Mountains State Park, Big Bend Ranch, and Marfa / Alpine RV parks are the stay. Self-contained vans have used nearby pullouts — confirm current TXDOT / county rules.",
    tripNotes:
      "Year-round, after dark. US-90 between Alpine and Marfa. Pair with Darkskies Davis Mountains if you want both mysteries.",
    etiquette:
      "Lights out except red. Don’t block the viewing pads. Ranch land off the highway is private.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Any clear night.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://visitmarfa.com/",
  },
  {
    id: "rachel-nevada",
    name: "Rachel, Nevada — Extraterrestrial Highway",
    shortName: "Rachel / ET Highway",
    kinds: ["ufo"],
    region: "West",
    country: "US",
    state: "NV",
    city: "Rachel",
    venue: "Little A'Le'Inn / NV-375",
    latitude: 37.645,
    longitude: -115.743,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["night-watch", "nearby-camp", "rv-friendly", "year-round"],
    whyGo:
      "The public edge of Area 51 country. A diner, a highway, and a dark basin. This is a van night, not a base tour.",
    campingNotes:
      "BLM basin camping when legal; the Inn has limited rooms. Do not camp at the gates. Fuel and water are scarce — fill in Alamo or Tonopah.",
    tripNotes:
      "Year-round. NV-375. Heat in summer, ice in winter. The military installation is closed. Period.",
    etiquette:
      "Stay on public pavement. No drones toward the range. Don’t harass Inn staff for secret tours they do not have.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Any night the highway is open.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://littlealeinn.com/",
  },
  {
    id: "pine-bush-ufo",
    name: "Pine Bush UFO",
    shortName: "Pine Bush",
    kinds: ["ufo"],
    region: "Northeast",
    country: "US",
    state: "NY",
    city: "Pine Bush",
    venue: "Town of Crawford / Pine Bush",
    latitude: 41.608,
    longitude: -74.299,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["festival", "nearby-camp", "night-watch"],
    whyGo:
      "Hudson Valley UFO country with a small-town festival and a skywatch culture. Close enough to NYC for a weekend, better as a Catskills camp.",
    campingNotes:
      "Orange County and Shawangunk camps. Not a speedway lot. Town streets are day-use.",
    tripNotes:
      "Festival typically May. Skywatch year-round. Confirm on pinebushufo.com / town listings. NY-17 / I-84.",
    etiquette:
      "Residential hamlet. Don’t idle a convoy on Main Street at 2 a.m. with high beams.",
    typical: {
      startMonth: 5,
      startDay: 16,
      endMonth: 5,
      endDay: 17,
      cadence: "single",
      notes: "May festival; watching is year-round.",
    },
    seasons: [
      { start: "2026-05-16", end: "2026-05-17", cadence: "single" },
    ],
    officialUrl: "https://www.pinebushufo.com/",
  },
  {
    id: "gettysburg-ghosts",
    name: "Gettysburg after dark",
    shortName: "Gettysburg ghosts",
    kinds: ["haunt"],
    region: "Northeast",
    country: "US",
    state: "PA",
    city: "Gettysburg",
    venue: "Gettysburg battlefield & town",
    latitude: 39.831,
    longitude: -77.231,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "overnight-hunt", "year-round"],
    whyGo:
      "The most-walked haunted battlefield in the country. Ghost tours in town; the park after sunset is a different, quieter trip. Also on RenCamp’s historical list.",
    campingNotes:
      "Gettysburg KOA, Drummer Boy, and county camps. NPS does not allow random overnighting on the field. Hotels for October weekends.",
    tripNotes:
      "Year-round tours. July 1–4 and October are packed. Confirm tour operators and park hours. US-15.",
    etiquette:
      "It is a cemetery and a park. No EMF theater on graves. Stay off earthworks. Licensed tours only after hours where required.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Tours year-round.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.nps.gov/gett/",
  },
  {
    id: "cryptozoology-museum",
    name: "International Cryptozoology Museum",
    shortName: "Cryptozoology Museum",
    kinds: ["cryptid"],
    region: "Northeast",
    country: "US",
    state: "ME",
    city: "Portland",
    venue: "4 Thompson's Point Road",
    latitude: 43.647,
    longitude: -70.29,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["museum", "nearby-camp", "year-round"],
    whyGo:
      "Loren Coleman’s museum: the physical catalog of cryptids. A rainy-day pin that justifies a Maine coast camping loop.",
    campingNotes:
      "Sebago and coastal Maine state parks. Portland is hotels and a van-unfriendly downtown. Thompson’s Point is the museum, not a camp.",
    tripNotes:
      "Year-round hours, confirm on cryptozoologymuseum.com. I-295.",
    etiquette:
      "It is a small museum. Don’t touch casts. Ask before photos of research materials.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Open most of the year; confirm hours.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://cryptozoologymuseum.com/",
  },
  {
    id: "caddo-lake",
    name: "Caddo Lake",
    shortName: "Caddo Lake",
    kinds: ["haunt", "cryptid"],
    region: "South",
    country: "US",
    state: "TX",
    city: "Uncertain",
    venue: "Caddo Lake State Park / Big Cypress Bayou",
    latitude: 32.711,
    longitude: -94.12,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "night-watch", "year-round"],
    whyGo:
      "Spanish moss, bayou night sounds, and a century of ghost-light stories. The camping is the attraction. Jefferson’s Bigfoot weekend is 30 minutes north.",
    campingNotes:
      "Caddo Lake State Park cabins and camps; some RV. Uncertain / Karnack have limited pads. Water and mosquitoes are the real cryptids.",
    tripNotes:
      "Year-round. Best in cooler months. TX-43. Confirm park reservations.",
    etiquette:
      "Paddle quietly at night. Private docks are not launches. Alligators are not a bit.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Any night the park is open.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://tpwd.texas.gov/state-parks/caddo-lake",
  },
  {
    id: "brown-mountain-lights",
    name: "Brown Mountain Lights",
    shortName: "Brown Mountain",
    kinds: ["ufo", "haunt"],
    region: "Southeast",
    country: "US",
    state: "NC",
    city: "Morganton",
    venue: "Wiseman's View / Lost Cove overlooks",
    latitude: 35.921,
    longitude: -81.746,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["night-watch", "nearby-camp", "rv-friendly", "year-round"],
    whyGo:
      "A documented mountain-light watch in the Linville Gorge. Bring a thermos, not a documentary crew.",
    campingNotes:
      "Linville Falls, Mortimer, and forest camps. Overlooks are not campsites. Short-rig friendly roads; some gravel.",
    tripNotes:
      "Year-round, after dark, weather willing. Blue Ridge Parkway / NC-181. Confirm forest road status.",
    etiquette:
      "Lights out at the overlook. Don’t block the one-lane. Gorge rims are unforgiving at night.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Clear nights.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.fs.usda.gov/r08/pisgah",
  },
  {
    id: "queen-mary",
    name: "The Queen Mary",
    shortName: "Queen Mary",
    kinds: ["haunt"],
    region: "West",
    country: "US",
    state: "CA",
    city: "Long Beach",
    venue: "1126 Queens Highway",
    latitude: 33.753,
    longitude: -118.19,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["overnight-hunt", "year-round"],
    whyGo:
      "A retired ocean liner you can sleep on and hunt after hours. Urban haunt, not a forest — still an overnight strangeness trip.",
    campingNotes:
      "Staterooms on the ship. No RV camping at the pier. Nearby Long Beach / Seal Beach parks if you insist on the van.",
    tripNotes:
      "Year-round tours and paranormal investigations. Confirm on queenmary.com. I-710.",
    etiquette:
      "It is a hotel and a historic ship. Stay in booked areas. Don’t open watertight doors for content.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Year-round.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.queenmary.com/",
  },
];

export function festById(id: string): Fest | undefined {
  return FESTS.find((fest) => fest.id === id);
}

export const REGIONS: Array<Fest["region"]> = [
  "Northeast",
  "Southeast",
  "Midwest",
  "South",
  "Southwest",
  "West",
  "Alaska",
  "Canada",
];

export const KINDS: Array<Fest["kinds"][number]> = ["haunt", "cryptid", "ufo"];
